export const CMP_PREFIX = "cso-portal";
export const ICON_PREFIX = "cso-portal-icon";
export const THEME_PREFIX = "cso-portal-theme";
